import type { ReactNode } from 'react'

/**
 * Paylaşılan boş-durum bileşeni (anayasa Page Standards → Durum Gösterimi + Reuse Mandate):
 * ikon + başlık + kısa açıklama. Yalnız "Veri yok" bırakılmaz. Tüm ekranlar bunu yeniden kullanır.
 */
export interface EmptyStateProps {
  title: string
  description?: string
  /** primeicons sınıfı (ör. "pi pi-inbox"). */
  icon?: string
  action?: ReactNode
}

export default function EmptyState({
  title,
  description,
  icon = 'pi pi-inbox',
  action,
}: Readonly<EmptyStateProps>) {
  return (
    <div className="ui-empty" role="status">
      <i className={`${icon} ui-empty-icon`} aria-hidden />
      <div className="ui-empty-title">{title}</div>
      {description && <div className="ui-empty-desc">{description}</div>}
      {action && <div className="ui-empty-action">{action}</div>}
    </div>
  )
}
